import jQuery from 'jquery';
$ = jQuery;

class HpaAlertMessages {

    constructor(messageContainerId) {
        this.messageContainer = false;

        const $messageContainer = $(messageContainerId);
        if (!$messageContainer.length) {
            console.error('class HpaAlertMessages: The messageContainer element ' + messageContainerId + ' does not exist.');
            return;
        }

        if ($messageContainer.length) this.messageContainer = $messageContainer;
    }

    scrollToMessages() {
        if (!this.messageContainer) {
            errorNotDefined();
            return;
        }

        $('body').scrollTo(this.messageContainer);
    }

    clearMessages() {
        if (!this.messageContainer) {
            errorNotDefined();
            return;
        }

        this.messageContainer.html('');
    }

    addMessage(message, messageType, dismissible, append) {
        if (!this.messageContainer) {
            errorNotDefined();
            return;
        }

        if (!messageType) messageType = 'info';
        if (typeof message === 'object') {
            message = message.join('<br>');
        }
        let messageHtml = `<div class="alert alert-${messageType} alert-dismissible" role="alert">`;
        if (dismissible === true) messageHtml += `<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>`;
        messageHtml += `${message}</div>`;
        if (append === true) {
            this.messageContainer.append(messageHtml);
        } else {
            this.messageContainer.html(messageHtml);
        }
    }

    errorNotDefined() {
        console.error('class HpaAlertMessages: The messageContainer is not defined. Check that the element exists.');
    }
}

export default HpaAlertMessages;



// WEBPACK FOOTER //
// ./js/lib/HpaAlertMessages.js